import React from 'react';
import { makeStyles } from '@material-ui/core';
import EmojiObjectsOutlinedIcon from '@material-ui/icons/EmojiObjectsOutlined';
import RichTextReactRenderer from 'components/RichTextReactRenderer';
import { SeriesResourceCard } from '../SeriesResourceCard';
import { SeriesStepperAuth } from './SeriesStepperAuth';

const useStyles = makeStyles(theme => ({
  resourceDescription: {
    display: 'flex',
    '& svg': {
      color: theme.palette.primary.secondary,
      marginRight: 8,
    },
  },
  richText: {
    '&  p': {
      fontSize: props => props.fontSize,
    },
  },
}));

export const SeriesResourceWithProgress = ({
  seriesSiteCopy,
  navbarPageSiteCopy,
  completedResourcesIds,
  resources,
  isAuthenticated,
  item,
  trackingProps = {
    path: 'series',
  },
  isDesktop,
  isTablet,
  isBigTablet,
  isMobile,
  activeResource,
  activeResourceIdx,
  handleCompleteChange,
  handleNext,
  completeResource,
  onProgressUpdate,
  onSeriesComplete,
  resourcesProgress,
  fontSize,
  resourceDescription,
  isSeriesComplete,
  completeSeriesAssessment,
  completedAssessments,
  linkAsPlainText,
  showProgressTracking = true,
  showActions = true,
  isManualSeriesCompletion,
  showOpenInNewIcon,
  showShareAction,
  renderHeartButton,
  assessmentSpanFullWidth,
}) => {
  const classes = useStyles();

  const handleProgressUpdate = (resource, completed) =>
    onProgressUpdate(item, resource, completed);

  return (
    <>
      {showProgressTracking && (
        <SeriesStepperAuth
          activeStep={completedResourcesIds.length}
          stepsCount={resources.length}
          seriesSiteCopy={seriesSiteCopy}
          navbarPageSiteCopy={navbarPageSiteCopy}
          trackingPath={trackingProps.path}
          isAuthenticated={isAuthenticated}
          item={item}
        />
      )}
      {resourceDescription && (
        <div className={classes.resourceDescription}>
          <EmojiObjectsOutlinedIcon />
          <RichTextReactRenderer
            className={classes.richText}
            data={resourceDescription}
          />
        </div>
      )}
      <SeriesResourceCard
        series={item}
        isDesktop={isDesktop}
        isTablet={isTablet}
        isBigTablet={isBigTablet}
        isMobile={isMobile}
        resource={activeResource}
        index={activeResourceIdx}
        handleCompleteChange={handleCompleteChange}
        completeResource={completeResource}
        handleNext={handleNext}
        resources={resources}
        completedResourcesIds={completedResourcesIds}
        seriesSiteCopy={seriesSiteCopy}
        trackingProps={trackingProps}
        fontSize={fontSize}
        onProgressUpdate={handleProgressUpdate}
        resourcesProgress={resourcesProgress}
        onSeriesComplete={onSeriesComplete}
        isSeriesComplete={isSeriesComplete}
        showActions={showActions}
        completeSeriesAssessment={completeSeriesAssessment}
        completedAssessments={completedAssessments}
        isManualSeriesCompletion={isManualSeriesCompletion}
        linkAsPlainText={linkAsPlainText}
        showOpenInNewIcon={showOpenInNewIcon}
        showShareAction={showShareAction}
        renderHeartButton={renderHeartButton}
        assessmentSpanFullWidth={assessmentSpanFullWidth}
      />
    </>
  );
};
